var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col flex-1"},[_c('AssetSelectionList',{ref:"list",attrs:{"module-name":_vm.$constants.ASSET,"fetch-fn":_vm.fetchAssetFn,"searchable":false,"scrollable":"","show-no-data":"","has-actions":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }